import { useFirstScreenAB } from './firstScreen/useFirstScreenAb';

function useShowBottomBenefits() {
    const state = useFirstScreenAB<{
        store_free_shipping: boolean;
        shipping_coupon: boolean;
        local_product: boolean;
        flash_sale: boolean;
    }>();

    return {
        showBottomBenefits: state,
    };
}

export default useShowBottomBenefits;
